import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            焦点专题
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            本期精选专题
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            编辑团队精心策划的深度专题内容，带你换个角度看生活
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.slice(0, 3).map((item, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-xl overflow-hidden group cursor-pointer hover:bg-background-200/70 transition-colors duration-200"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
                  {item.tag}
                </span>
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.summary}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          {carouselItems.slice(3, 5).map((item, index) => (
            <div
              key={index + 3}
              className="bg-background-100 rounded-xl overflow-hidden group cursor-pointer hover:bg-background-200/70 transition-colors duration-200 flex flex-col sm:flex-row"
            >
              <div className="sm:w-2/5 aspect-[16/10] sm:aspect-auto overflow-hidden flex-shrink-0">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex flex-col justify-center">
                <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 self-start">
                  {item.tag}
                </span>
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.summary}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}